/**
 * @file StopListAck.tsx
 * @description Ошибки стоп-листа (SB58, SEO14) при записи SEO-настроек и
 * галочка владельца «всё равно сохраняю — отвечаю за это я» (SB125, тот же
 * `PublishAcknowledgeRow`, что в окне публикации) — phase19.16, партия Р3в,
 * v0.19.64. Общая для «Сохранить» карточки, «Применить» неопубликованных
 * правок и «Вернуть прежнее»: отказ 409 `site_seo_text_blocked` → список и
 * галочка, повтор запроса с `acknowledgeChecks: true`.
 */

import { PublishAcknowledgeRow } from "../../site-view/dialogs/PublishAcknowledgeRow";
import type { PublishCheck } from "../../../lib/site-view/types";

interface Props {
  checks: PublishCheck[];
  ack: boolean;
  onAck: (value: boolean) => void;
}

export function StopListAck({ checks, ack, onAck }: Props) {
  if (checks.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      <ul className="type-body flex list-disc flex-col gap-1 pl-5 text-destructive">
        {checks.map((check) => (
          <li key={`${check.code}:${check.message}`}>{check.message}</li>
        ))}
      </ul>
      <PublishAcknowledgeRow errors={checks} checked={ack} onChange={onAck} allowed />
    </div>
  );
}
